enum ReviewPlatformNames {
  appStore = 'App Store',
  capterra = 'Capterra',
  g2 = 'G2',
  playStore = 'Play Store',
  trustpilot = 'Trustpilot',
  trustradius = 'Trustradius',
  productHunt = 'Product Hunt',
  salesforce = 'Salesforce',
  wordpress = 'Wordpress',
  shopify = 'Shopify',
}

enum ReviewPlatformLabels {
  appStore = 'App Store',
  capterra = 'Capterra',
  g2 = 'G2',
  playStore = 'Play Store',
  trustpilot = 'Trustpilot',
  trustradius = 'Trustradius',
  productHunt = 'Product Hunt',
  salesforce = 'Salesforce AppExchange',
  wordpress = 'WordPress',
  shopify = 'Shopify',
}

enum SyncIntegrationNames {
  freshdesk = 'freshdesk',
  gong = 'gong',
  helpscout = 'helpscout',
  intercom = 'intercom',
  slack = 'slack',
  tldv = 'tldv',
  zendesk = 'zendesk',
  zoom = 'zoom',
  api = 'api',
  imports = 'imports',
  zapier = 'zapier',
  // review platforms
  trustpilotReviews = 'trustpilot-reviews',
  appStoreReviews = 'appstore-reviews',
  playStoreReviews = 'playstore-reviews',
  g2Reviews = 'g2-reviews',
  capterraReviews = 'capterra-reviews',
  trustradiusReviews = 'trustradius-reviews',
  productHuntReviews = 'producthunt-reviews',
  salesforceReviews = 'salesforce-reviews',
  wordpressReviews = 'wordpress-reviews',
  shopifyReviews = 'shopify-reviews',
}

const ReviewPlatformToSyncNameMapping: Record<ReviewPlatformNames, SyncIntegrationNames> = {
  [ReviewPlatformNames.appStore]: SyncIntegrationNames.appStoreReviews,
  [ReviewPlatformNames.capterra]: SyncIntegrationNames.capterraReviews,
  [ReviewPlatformNames.g2]: SyncIntegrationNames.g2Reviews,
  [ReviewPlatformNames.playStore]: SyncIntegrationNames.playStoreReviews,
  [ReviewPlatformNames.trustpilot]: SyncIntegrationNames.trustpilotReviews,
  [ReviewPlatformNames.trustradius]: SyncIntegrationNames.trustradiusReviews,
  [ReviewPlatformNames.productHunt]: SyncIntegrationNames.productHuntReviews,
  [ReviewPlatformNames.salesforce]: SyncIntegrationNames.salesforceReviews,
  [ReviewPlatformNames.wordpress]: SyncIntegrationNames.wordpressReviews,
  [ReviewPlatformNames.shopify]: SyncIntegrationNames.shopifyReviews,
};

enum SyncReviewIntegrationNames {
  trustpilotReviews = SyncIntegrationNames.trustpilotReviews,
  appStoreReviews = SyncIntegrationNames.appStoreReviews,
  playStoreReviews = SyncIntegrationNames.playStoreReviews,
  g2Reviews = SyncIntegrationNames.g2Reviews,
  capterraReviews = SyncIntegrationNames.capterraReviews,
  trustradiusReviews = SyncIntegrationNames.trustradiusReviews,
  productHuntReviews = SyncIntegrationNames.productHuntReviews,
  salesforceReviews = SyncIntegrationNames.salesforceReviews,
  wordpressReviews = SyncIntegrationNames.wordpressReviews,
  shopifyReviews = SyncIntegrationNames.shopifyReviews,
}

enum ZapierTemplateNames {
  googleForms = 'google-forms',
  typeform = 'typeform',
  surveyMonkey = 'survey-monkey',
  generic = 'generic', // not a specific integration, but a catch-all for any other Zapier integrations
}

enum IntegrationItemNames {
  call = 'call',
  conversation = 'conversation',
  message = 'message',
  review = 'review',
  ticket = 'ticket',
}

const CreditsPerIntegrationItemName: Record<IntegrationItemNames, number> = {
  [IntegrationItemNames.call]: 5,
  [IntegrationItemNames.conversation]: 1,
  [IntegrationItemNames.message]: 1,
  [IntegrationItemNames.review]: 1,
  [IntegrationItemNames.ticket]: 1,
};

type InternalIntegrations =
  | SyncIntegrationNames.api
  | SyncIntegrationNames.imports
  | SyncIntegrationNames.zapier;

type ExternalIntegrationNames = Exclude<SyncIntegrationNames, InternalIntegrations>;

export type { ExternalIntegrationNames };

export {
  CreditsPerIntegrationItemName,
  ReviewPlatformNames,
  ReviewPlatformLabels,
  ReviewPlatformToSyncNameMapping,
  SyncIntegrationNames,
  SyncReviewIntegrationNames,
  ZapierTemplateNames,
  IntegrationItemNames,
};
